import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import AnnualReportProxyStatementDialog from './AnnualReportProxyStatementDialog';
import FractionalSharesDialog from '../common/dialogs/FractionalSharesDialog';

import { UserRoles } from '../../../constants';
import employeeService from '../../../services/Employee.service';
import { history } from '../../../store';
import { NavigationTo } from '../../../layouts/v2/common';

import { Row, Col } from '@amzn/stencil-react-components/layout';
import { H2, Text } from '@amzn/stencil-react-components/text';
import { ButtonCard } from '@amzn/stencil-react-components/card';

export class PopularActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAnnualReportDialogVisible: false,
      isFractionalSharesDialogVisible: false,
    };

    this.card = createRef();
  }

  onFractionalSharesClickButton = () => {
    this.setState({
      isFractionalSharesDialogVisible: true,
    });
  };

  onCloseFractionalSharesDialog = () => {
    this.setState({
      isFractionalSharesDialogVisible: false,
    });
  };

  onAnnualReportClickButton = () => {
    this.setState({
      isAnnualReportDialogVisible: true,
    });
  };

  onCloseAnnualReportDialog = () => {
    this.setState({
      isAnnualReportDialogVisible: false,
    });
  };

  goToBrokerPage = () => {
    history.push(NavigationTo.AvailableBrokers, {});
  };

  goToStockAwardsPage = () => {
    history.push(NavigationTo.StockAwards, {});
  };

  createActionCard = (textContent, header, buttonAction, innerRef=null) => {
    return (
      <ButtonCard ref={innerRef} width="456px" onClick={() => buttonAction()}>
        <Col gridGap="S200" alignItems="flex-start">
          <Text fontSize="T300" fontWeight="bold" textAlign="left">{header}</Text>
          <Text color="neutral70" textAlign="left">{textContent}</Text>
        </Col>
      </ButtonCard>
    );
  };

  render() {
    const { t, employee } = this.props;

    const shouldShowBrokerAction =
      !employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE) &&
      employeeService.showAvailableBrokers(employee) &&
      !employeeService.isBrokerChoiceOne(employee);

    return (
      <Col gridGap="S400">
        <H2>{t('PopularActions.Title')}</H2>
        <Row gridGap="S300" flexWrap="wrap">
          {shouldShowBrokerAction &&
            this.createActionCard(
              t('PopularActions.CompareBrokersContent'),
              t('PopularActions.CompareBrokersButton'),
              this.goToBrokerPage,
            )}
          {this.props.fractionalMode &&
            employeeService.hasFractionalEligibleVest(employee) &&
            this.createActionCard(
              t('PopularActions.FractionalSharesContent'),
              t('PopularActions.FractionalSharesButton'),
              this.onFractionalSharesClickButton,
              this.card
            )}
          {!this.props.fractionalMode &&
            this.createActionCard(
              t('PopularActions.NeedSummaryContent'),
              t('PopularActions.NeedSummaryButton'),
              this.goToStockAwardsPage,
            )}
          {this.createActionCard(
            t('PopularActions.WantToSeeContent'),
            t('PopularActions.WantToSeeButton'),
            this.onAnnualReportClickButton,
          )}
        </Row>
        <AnnualReportProxyStatementDialog
          visible={this.state.isAnnualReportDialogVisible}
          onCloseDialog={this.onCloseAnnualReportDialog}
        />
        <FractionalSharesDialog
          visible={this.state.isFractionalSharesDialogVisible}
          onDialogClose={this.onCloseFractionalSharesDialog}
          refFrom={this.card}
        />
      </Col>
    );
  }
}

const mapState = (state) => ({
  employee: state.employee,
  fractionalMode: state.static_content.fractional_mode,
});

export default connect(mapState)(withTranslation('translationsV2')(PopularActions));
